export default __webpack_public_path__ + "static/media/AssetMonitoring300.27d869ca.jpg";